import { useCallback, useEffect } from 'react';
import useExtensionCommand from './useExtensionCommand';

const OntruckExtensionReceiver = () => {
  const location = window.location.origin;
  const consumeCommand = useExtensionCommand();

  const handleMessageEvent = useCallback(
    (event) => {
      if (event.origin !== location) return;
      if (event.data.isOntruckExtensionMessage) {
        const command = event.data.command;
        consumeCommand(command);
      }
    },
    [consumeCommand, location]
  );

  useEffect(() => {
    window.addEventListener('message', handleMessageEvent, false);
    return () => {
      window.removeEventListener('message', handleMessageEvent);
    };
  }, [handleMessageEvent]);

  return <></>;
};

export default OntruckExtensionReceiver;
